import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import DiskCleanup from 'components/DiskCleanup';
import DiskCleanupContext from 'components/DiskCleanupContext';

import { withData } from 'lib';
import { ToolsDiskCleanupPageQuery } from '__generated__/ToolsDiskCleanupPageQuery.graphql';

const query = graphql`
  query ToolsDiskCleanupPageQuery(
    $input: DiskCleanerInput
    $scan: Boolean = false
  ) {
    ...DiskCleanup_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<ToolsDiskCleanupPageQuery>;
};

const ToolsDiskCleanupPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<ToolsDiskCleanupPageQuery>(
    query,
    preloadedQuery
  );

  return (
    <Page
      breadcrumbs={[
        { name: 'Įrankiai', link: '/tools' },
        { name: 'Disko valymas' },
      ]}>
      <DiskCleanupContext>
        <DiskCleanup data={data} />
      </DiskCleanupContext>
    </Page>
  );
};

export default withData<ToolsDiskCleanupPageQuery>({
  query,
})(ToolsDiskCleanupPage);
